import { Image } from '@bonanza-social/moonlight';
import { memo } from 'react';
import { StatusGemGlowProps } from './StatusGemGlow.types';

function StatusGemGlow({ status }: StatusGemGlowProps) {
  return (
    <Image
      position="absolute"
      top="-space-1400"
      bottom="-space-1400"
      left="-space-1400"
      right="-space-1400"
      name={`status.${status}Glow`}
      zIndex={-10}
      opacity={0.5}
    />
  );
}

export default memo(StatusGemGlow);
